<template>
  <div>
    <div
      :class="`bg-white
        border
        rounded
        p-2
        my-3
        text-center text-${variant}`"
    >
      <strong v-text="title" />
      <ul class="list-unstyled mt-3 m-0 px-0 text-justify text-break">
        <li class="mb-2 fs_12" v-for="(item, index) in items" :key="index">
          <i :class="`${listIcon} mr-1`" />
          <span v-text="item" />
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
    listIcon: {
      type: String,
      default: "",
    },
    variant: {
      type: String,
      default: "",
    },
  },
};
</script>